import React, { useEffect } from 'react'
import { isEmpty } from 'lodash'
import Masonry from 'react-responsive-masonry'
import ReviewItem from './ReviewItem/ReviewItem'
import styles from '../UserCard.module.scss'
import { useDispatch } from 'react-redux'
import { setReviewsInfo } from '../../../redux/actions/userCard.action'
import { ReactComponent as NoInfoImage } from '../../../assets/images/reviews_sub.svg'
import { useMediaQuery } from '@mui/material'

const Reviews = ({ userCardData }) => {
  const dispatch = useDispatch()
  const isOneColumn = useMediaQuery('(max-width:1199.98px)')

  useEffect(() => {
    return () => {
      dispatch(setReviewsInfo([]))
    }
  }, [dispatch])
  if (isEmpty(userCardData.reviews)) {
    return (
      <div className={styles.noInfo}>
        <NoInfoImage width={isOneColumn ? '100%' : 400} height={isOneColumn ? 'auto' : 260} />
        <p>You don’t have any reviews yet. </p>
      </div>
    )
  } else {
    return (
      <Masonry columnsCount={isOneColumn ? 1 : 2} gutter={'16px'}>
        {userCardData.reviews.map((review, index) => review.questions && <ReviewItem key={index} review={review} />)}
      </Masonry>
    )
  }
}

export default Reviews
